import { render } from "./PatientReportPreview.vue?vue&type=template&id=f12e4eae"
import script from "./PatientReportPreview.vue?vue&type=script&lang=js"
export * from "./PatientReportPreview.vue?vue&type=script&lang=js"

import "./PatientReportPreview.vue?vue&type=style&index=0&id=f12e4eae&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/PatientReportPreview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f12e4eae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f12e4eae', __exports__)) {
    console.log('reload')
    api.reload('f12e4eae', __exports__)
  }
  
  module.hot.accept("./PatientReportPreview.vue?vue&type=template&id=f12e4eae", () => {
    console.log('re-render')
    api.rerender('f12e4eae', render)
  })

}


export default __exports__